import { observer } from 'mobx-react';
import moment from 'moment';
import { Button } from 'primereact/button';
import { Column, ColumnProps } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { RefObject } from 'react';
import { RouterProps } from 'react-router';
import { Flex } from 'reflexbox';

import { DataSource } from '../../../models/DataSource';
import { DataTableFilterService } from '../../../services/DataTableFilterService';
import { MonitoringRestService } from '../../../services/MonitoringRestService';
import { DependencyContainer } from '../../../utils/DependencyInjection';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import { IReportFilterContainerValue, ReportFilterContainer } from './ReportFilterContainer';
import { DateHelper } from '../../../utils/DateHelper';
import OntimeDummyData from './OntimeDummyData.json';

export interface IReportOntimePerformancePickupContainerQuery {
  filters: IReportFilterContainerValue;
}

@observer
export class ReportOntimePerformancePickupContainer extends React.Component<RouterProps, any> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);

  reportData: any = [];
  growl;
  dataSource = new DataSource<any>();

  refFilter: RefObject<ReportFilterContainer> = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      exportExcelLoading: false,
      showExportDialog: false,
      showLoading: false,
      showDialog: false,
    }
  }

  componentDidMount() {
  
  }

  loadData() {
    const filterParams = this.refFilter.current!.formValues;
    const fParams = Object.assign({}, filterParams);

    if (fParams.startDate) fParams.startDate = DateHelper.formatLocalDateForQueryParam(fParams.startDate);
    if (fParams.endDate) fParams.endDate = DateHelper.formatLocalDateForQueryParam(fParams.endDate);

    this.setState({ showLoading: true, showDialog: true });
    this.dataSource.loading = true;

    setTimeout(
      () => {
        this.reportData = OntimeDummyData;
        this.populateDataSource();
        this.dataSource.loading = false;
        this.setState({ showLoading: false, showDialog: false });
      }, 2000
    )
    // this.monitoringRestService
    //   .post('pickup/monitoring-pop', fParams)
    //   .subscribe(
    //     response => {
    //       this.reportData = response;
    //       this.populateDataSource();
    //     },
    //     error => {
    //       this.dataSource.loading = false;
    //       this.setState({ showLoading: false, showDialog: false });
    //     },
    //     () => {
    //       this.dataSource.loading = false;
    //       this.setState({ showLoading: false, showDialog: false });
    //     },
    //   );
  }

  populateDataSource() {
    if (this.reportData && this.reportData.length) {
      this.dataSource.setData(this.reportData);
      this.dataSource.setTotal(this.reportData.length);
    } else {
      this.dataSource.setData([]);
      this.dataSource.setTotal(0);
    }
  }

  columnDateFormat = (rowData, column: ColumnProps) => {
    return (
      (rowData[column.field!] != null) ? moment(new Date(rowData[column.field!])).utc().format('DD-MM-YYYY HH:mm') : ''
    );
  }

  render() {
    const footer = 'Total data: ' + this.dataSource.total;

    return (
      <div>
        <Dialog header="Informasi" visible={this.state.showExportDialog} style={{width: '40vw'}} modal={true} onHide={() => this.setState({showExportDialog: false})}>
          Export excel sedang berjalan, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Dialog header="Informasi" visible={this.state.showDialog} style={{ width: '40vw' }} modal={true} onHide={() => this.setState({ showDialog: false })}>
          Sedang memuat data, mohon jangan tinggalkan halaman ini
        </Dialog>

        <Growl ref={el=> this.growl = el} style={{marginTop: '75px'}}/>

        <div className="card">
          <h2>On Time Performance Pickup</h2>
        </div>

        <Flex className="card w-full">
          <Flex className="w-full" column>
            <ReportFilterContainer ref={this.refFilter} />
            <br/>
            <Flex>
              <Button
                className="p-button-success mr-2"
                label="Tampilkan"
                icon={(this.state.showLoading) ? "pi pi-spin pi-spinner" : ""}
                disabled={(this.state.showLoading)}
                onClick={() => this.loadData()}
              />
            </Flex>
          </Flex>
        </Flex>

        <div className="card">
          <DataTable
            emptyMessage={'Tidak ada data untuk ditampilkan.'}
            scrollable={true}
            scrollHeight="550px"
            style={{ width: '100%' }}
            className="mt-4"
            paginator={true}
            rows={50} 
            rowsPerPageOptions={[10, 50, 100, 150]}
            value={this.dataSource.data}
            loading={this.dataSource.loading}
            footer={footer}>
            <Column
              field="branch"
              header="Cabang"
              sortable={false}
              style={{ width: '150px' }}
            />
            <Column
              field="2Hours"
              header="2Hours"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="perc2Hours"
              header="%_2"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="3Hours"
              header="3Hours"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="perc3Hours"
              header="%_3"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="4Hours"
              header="4Hours"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="perc4Hours"
              header="%_4"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="5Hours"
              header="5Hours"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="perc5Hours"
              header="%_5"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="6Hours"
              header="6Hours"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="perc6Hours"
              header="%_6"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="7Hours"
              header="7Hours"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="perc7Hours"
              header="%_7"
              sortable={false}
              style={{ width: '100px' }}
            />
            <Column
              field="totalResi"
              header="Total Resi SPK"
              sortable={false}
              style={{ width: '100px' }}
            />
          </DataTable>

          {/* <Paginator
            totalRecords={this.dataSource.total}
            first={this.dataSource.offset}
            rows={this.dataSource.rows}
            rowsPerPageOptions={this.dataSource.rowsOptions}
            onPageChange={e => this.dataSource.fromPageState(e)} 
          /> */}
        </div>
      </div>
    );
  }
}